import React, { useMemo } from "react";
import {
    FormGroup,
    Button,
    Modal,
    Dropdown,
    ListGroupItem,
    MenuItem,
    Glyphicon,
} from "react-bootstrap";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import labelsRu from 'react-phone-number-input/locale/ru';
import labelsEn from 'react-phone-number-input/locale/en';
import { authTypesOptions as _authTypesOptions } from "./lib";

const countries = getCountries();

const CustomCountrySelect = ({
    locale,
    onChange,
    isSaving,
    allowedPhoneCountryCodes,
}) => {
    const sortedCountries = useMemo(() => {
        return countries.sort((a, b) => labelsRu[a].localeCompare(labelsRu[b], 'ru'));
    }, []);

    return (
        <Dropdown
            id="add-button"
            disabled={isSaving}
        >
            <Dropdown.Toggle>
                {locale('settings.allowedPhoneCountryCodes.add')}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {
                    sortedCountries.map((country) => {
                        const countryCode = '+' + getCountryCallingCode(country);
                        if (allowedPhoneCountryCodes?.includes(countryCode)) {
                            return null;
                        }

                        return (
                            <MenuItem
                                key={country}
                                onClick={() => onChange(countryCode)}
                            >
                                {labelsRu[country]} ({labelsEn[country]}) {countryCode}
                            </MenuItem>
                        );
                    })
                }
            </Dropdown.Menu>
        </Dropdown>
    );
};

const CodesEditModal = ({ locale, allowedPhoneCountryCodes = [], handleSave, isSaving }) => {
    const handleAddCountryCode = (code) => {
        handleSave({allowedPhoneCountryCodes: [...allowedPhoneCountryCodes, code]});
    }

    const handleDeleteCountryCode = (index) => {
        handleSave({allowedPhoneCountryCodes: allowedPhoneCountryCodes.filter((_, i) => i !== index)});
    }

    return (
        <>
        <Modal.Header closeButton>
            <Modal.Title>{locale('settings.allowedPhoneCountryCodes.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <FormGroup>
                <CustomCountrySelect
                    locale={locale}
                    isSaving={isSaving}
                    allowedPhoneCountryCodes={allowedPhoneCountryCodes}
                    onChange={handleAddCountryCode}
                />
            </FormGroup>

            {allowedPhoneCountryCodes?.map((countryCode, index) => (
                <ListGroupItem
                    key={countryCode}
                    style={{
                        padding: '4px 4px 4px 12px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        height: '44px',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', gap: '0.5rem' }}>
                        <span
                            style={{
                                fontSize: '1.2rem',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                maxWidth: 150,
                            }}
                        >
                            {countryCode}
                        </span>
                    </div>
                    <Button disabled={isSaving} bsStyle="danger" onClick={() => handleDeleteCountryCode(index)}><Glyphicon glyph="trash" /></Button>
                </ListGroupItem>
            ))}
        </Modal.Body>
        </>
    );
}

export default CodesEditModal;